import styled from 'styled-components';
export const OffsetTextContainer = styled.span `
  align-items: center;
  justify-content: center;
`;
export const OffsetText = styled.span `
  font: var(--body-xs-medium) !important;
  font-size: 10px !important;
  line-height: 20px !important;
`;
